function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 13.4c-.633 0-1.2.25-1.633.642l-5.942-3.458c.042-.192.075-.384.075-.584 0-.2-.033-.391-.075-.583L13.3 5.992a2.49 2.49 0 001.7.675c1.383 0 2.5-1.117 2.5-2.5s-1.117-2.5-2.5-2.5a2.497 2.497 0 00-2.5 2.5c0 .2.033.392.075.583L6.7 8.175A2.49 2.49 0 005 7.5 2.497 2.497 0 002.5 10c0 1.384 1.117 2.5 2.5 2.5.658 0 1.25-.258 1.7-.675l5.933 3.467a2.354 2.354 0 00-.066.542A2.436 2.436 0 0015 18.267a2.436 2.436 0 002.433-2.433A2.436 2.436 0 0015 13.4z",
  fill: "currentColor"
});

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgShare;